/* =========================================================
   MALERMEISTER HEINRICH
   TÜREN-RECHNER → HULK FORM BUILDER

   Datei:
   assets/mh-tueren-anfrage-transfer.js

   Hulk Form ID:
   eZOWgvLOJEz8NBHMdRohBA

   Storage:
   mh_tueren_request

   Nachricht:
   MH_TUEREN_DATA
   ========================================================= */

(function () {

  const STORAGE_KEY =
    "mh_tueren_request";

  const FORM_ID =
    "eZOWgvLOJEz8NBHMdRohBA";


  /* =======================================================
     EURO
     ======================================================= */

  function euro(value) {

    return new Intl.NumberFormat(
      "de-DE",
      {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    ).format(
      Number(value || 0)
    );

  }


  /* =======================================================
     KALKULATION LESEN
     ======================================================= */

  function readCalculation() {

    const raw =
      localStorage.getItem(
        STORAGE_KEY
      );


    if (!raw) {

      console.log(
        "MH Türen Transfer: Keine Kalkulation vorhanden."
      );

      return null;

    }


    try {

      return JSON.parse(
        raw
      );

    } catch (error) {

      console.error(
        "MH Türen Transfer: Kalkulationsdaten ungültig.",
        error
      );

      return null;

    }

  }


  /* =======================================================
     TÜREN-ZUSAMMENFASSUNG
     ======================================================= */

  function buildDoorPositions(calc) {

    if (
      !calc ||
      !Array.isArray(calc.items)
    ) {

      return "";

    }


    return calc.items
      .map(
        function (item, index) {

          const parts = [];


          parts.push(
            "Position " +
            (index + 1) +
            ": " +
            (item.qty || 1) +
            " × " +
            (item.label || "Tür")
          );


          if (
            item.scopeLabel
          ) {

            parts.push(
              item.scopeLabel
            );

          }


          if (
            item.threshold
          ) {

            parts.push(
              "Türschwelle lackieren"
            );

          }


          if (
            item.review
          ) {

            parts.push(
              "Preis nach Prüfung"
            );

          } else {

            parts.push(
              euro(item.net) +
              " netto"
            );

          }


          return parts.join(
            " | "
          );

        }
      )
      .join(
        "\n"
      );

  }


  /* =======================================================
     DATENPAKET
     ======================================================= */

  function buildPayload() {

    const calc =
      readCalculation();


    if (!calc) {

      return null;

    }


    return {

      type:
        "MH_TUEREN_DATA",

      values: {

        tuer_plz:
          calc.plz || "",


        tuer_positionen:
          buildDoorPositions(
            calc
          ),


        tuer_anzahl:
          String(
            calc.totalQty || 0
          ),


        tuer_lackfarbton:
          calc.color || "Weiß",


        tuer_lackierarbeiten_netto:
          euro(
            calc.workNet
          ),


        tuer_anfahrt:
          euro(
            calc.travelGross
          ) +
          " brutto",


        tuer_mindestauftragswert:
          euro(
            calc.minNet || 400
          ),


        tuer_mwst:
          euro(
            calc.vat
          ),


        tuer_gesamt_netto:
          euro(
            calc.totalNet
          ),


        tuer_gesamt_brutto:
          euro(
            calc.gross
          ),


        tuer_datum:
          calc.date || ""

      }

    };

  }


  /* =======================================================
     HULK IFRAME FINDEN
     ======================================================= */

  function getHulkFrame() {

    /*
    Hulk verwendet normalerweise:
    frame_FORMID
    */

    const exactFrame =
      document.getElementById(
        "frame_" +
        FORM_ID
      );


    if (
      exactFrame &&
      exactFrame.contentWindow
    ) {

      return exactFrame;

    }


    /*
    Sicherheit:
    falls Hulk die iframe-ID etwas anders erzeugt.
    */

    const frames =
      document.querySelectorAll(
        "iframe"
      );


    for (
      let i = 0;
      i < frames.length;
      i++
    ) {

      const frame =
        frames[i];


      const id =
        String(
          frame.id || ""
        );


      const src =
        String(
          frame.src || ""
        );


      if (
        id.indexOf(FORM_ID) !== -1 ||
        src.indexOf(FORM_ID) !== -1
      ) {

        return frame;

      }

    }


    return null;

  }


  /* =======================================================
     AN HULK SENDEN
     ======================================================= */

  function sendToHulk() {

    const payload =
      buildPayload();


    if (!payload) {

      return false;

    }


    const frame =
      getHulkFrame();


    if (
      !frame ||
      !frame.contentWindow
    ) {

      console.log(
        "MH Türen Transfer: Hulk-iframe noch nicht gefunden."
      );

      return false;

    }


    frame.contentWindow.postMessage(
      payload,
      "https://formbuilder.hulkapps.com"
    );


    console.log(
      "MH Türen Transfer: Daten an Hulk gesendet.",
      payload
    );


    return true;

  }


  /* =======================================================
     WENN DER RECHNER NEU BERECHNET
     ======================================================= */

  window.addEventListener(
    "mh:tueren-calculation-updated",
    function () {

      setTimeout(
        sendToHulk,
        100
      );


      setTimeout(
        sendToHulk,
        600
      );

    }
  );


  /* =======================================================
     ANFRAGE-BUTTON
     ======================================================= */

  document.addEventListener(
    "click",
    function (event) {

      if (
        event.target &&
        event.target.closest &&
        event.target.closest(
          "[data-to-form]"
        )
      ) {

        setTimeout(
          sendToHulk,
          100
        );


        setTimeout(
          sendToHulk,
          700
        );


        setTimeout(
          sendToHulk,
          1500
        );

      }

    },
    true
  );


  /* =======================================================
     HULK IFRAME WIRD GELADEN
     ======================================================= */

  document.addEventListener(
    "load",
    function (event) {

      const target =
        event.target;


      if (
        !target ||
        target.tagName !==
          "IFRAME"
      ) {

        return;

      }


      if (
        String(
          target.id || ""
        ).indexOf(FORM_ID) !== -1 ||
        String(
          target.src || ""
        ).indexOf(FORM_ID) !== -1
      ) {

        setTimeout(
          sendToHulk,
          300
        );


        setTimeout(
          sendToHulk,
          1000
        );

      }

    },
    true
  );


  /* =======================================================
     START
     ======================================================= */

  let attempts = 0;


  const timer =
    setInterval(
      function () {

        attempts++;


        sendToHulk();


        if (
          attempts >= 30
        ) {

          clearInterval(
            timer
          );

        }

      },
      500
    );


  console.log(
    "MH Türen Transfer: bereit."
  );

})();